import produce from 'immer';
import { combineReducers } from 'redux';
import { AssistantRun } from '../../types/resources';
import { AssistantRunActionType, AssistantRunAction } from '../../actions/assistantRunActions';

interface AssistantRunState {
  byId: Record<string, AssistantRun>;
  allIds: string[];
}

export const initialState: AssistantRunState = {
  byId: {},
  allIds: [],
};

const byId = (state = initialState.byId, action: AssistantRunAction) =>
  produce(state, (draft) => {
    switch (action.type) {
      case AssistantRunActionType.LIST_ASSISTANT_RUNS:
        return {};
      case AssistantRunActionType.LIST_ASSISTANT_RUNS_OK: {
        action.data.data.forEach((assRun) => {
          draft[assRun.id] = assRun;
        });

        break;
      }
      case AssistantRunActionType.DELETE_ASSISTANT_RUN_OK: {
        delete draft[action.assistantRunId];
        break;
      }
      case AssistantRunActionType.LIST_WORKSPACE_ASSISTANT_RUNS_OK: {
        action.data.forEach((assRun) => {
          draft[assRun.id] = assRun;
        });

        break;
      }
      case AssistantRunActionType.GET_ASSISTANT_RUN_OK: {
        draft[action.data.id] = action.data;
        break;
      }
      default:
        return state;
    }
  });

const allIds = (state = initialState.allIds, action: AssistantRunAction) => {
  switch (action.type) {
    case AssistantRunActionType.LIST_ASSISTANT_RUNS:
      return [];
    case AssistantRunActionType.LIST_ASSISTANT_RUNS_OK:
      return action.data.data.map((assRun) => assRun.id);
    case AssistantRunActionType.LIST_WORKSPACE_ASSISTANT_RUNS_OK:
      return action.data.map((assRun) => assRun.id);
    case AssistantRunActionType.GET_ASSISTANT_RUN_OK:
      return [action.data.id];
    case AssistantRunActionType.DELETE_ASSISTANT_RUN_OK:
      return state.filter((id) => id !== action.assistantRunId);
    default:
      return state;
  }
};

export default combineReducers({
  byId,
  allIds,
});
